import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import whatsapp from './img/whatsapp_icon.png';
import logoMasdel from './img/Logo-Masdel.png';
import Particles from 'react-particles-js';
import particlesConfig from './config/configParticles';

class App extends Component {
  constructor() {
    super();      
  }

  state = {
    listaDepartamentos: [],
    listaMunicipios: [],
    listaConsultoras: [],
    aceptar: false     
  }  

  componentDidMount() { 
    var UrlDeptoGua = "https://marykay.com.gt/revista/";
    var UrlDeptoElsa = "https://marykay.com.gt/buscadorElSalvador/departamento.php";
    var UrlMuniGua = "https://marykay.com.gt/revista/municipiosguate.php?id=";
    var UrlMuniElsa = "https://marykay.com.gt/buscadorElSalvador/municipio.php?id=";    
    var UrlConsultoraGua = "https://marykay.com.gt/revista/consultoras.php?id=";
    var UrlConsultoraElsa = "https://marykay.com.gt/buscadorElSalvador/buscador.php?id=";
    var selectdepartamento = document.getElementById('listaDepartamentos');
    var btnRegresar = document.getElementById("btnRegresar");
    var contenido = document.getElementById('contenido');
    var selectmunicipio = document.getElementById('listaMunicipios');
    var divp1 = document.getElementById("parrafo1");
    var divp2 = document.getElementById("parrafo2");
    btnRegresar.style.display = "none";
    contenido.style.display = "none";
    document.getElementById('listaMunicipios').option = "Guatemala"
    selectdepartamento.style.display = "none";
    selectmunicipio.style.display = "none";    
    var inlineCheckbox1 = document.getElementById('inlineCheckbox1');

   function checked(){     
     if (inlineCheckbox1.checked == true){
      selectdepartamento.style.display = "block";
      selectmunicipio.style.display = "block"; 
     }else{
      selectdepartamento.style.display = "none";
      selectmunicipio.style.display = "none";
   }
   }

   inlineCheckbox1.addEventListener('change', (event) => {
     checked();
   }
   )

    fetch(UrlDeptoGua)
      .then(res => res.json())
      .then(data => {
        console.log(data)
        this.setState({ listaDepartamentos: data.listaDepartamentos })
        checked();
      })

    selectdepartamento.addEventListener('change', (event) => {
      fetch(UrlMuniGua + selectdepartamento.value)
        .then(res => res.json())
        .then(data => {
          try {
            console.log(data)
            this.setState({ listaMunicipios: data.listaMunicipios })
          } catch (error) {
            console.error();
            window.alert("Error seleccionando el departamento")
            window.location.href = window.location.href;
          }
        })
    })

    selectmunicipio.addEventListener('change', (event) => {
      var whatsappimg = whatsapp;
      divp1.style.display = "none";
      divp2.style.display = "none";
      selectmunicipio.style.display = "none";
      selectdepartamento.style.display = "none";
      inlineCheckbox1.style.display = "none";

      fetch(UrlConsultoraGua + selectmunicipio.value)
        .then(res => res.json())
        .then(data => {
          try {
            tabla(data.listaConsultoras);
            btnRegresar.style.display = "block";
            contenido.style.display = "block";

          } catch (error) {
            console.error();
            //window.alert("Municipio sin consultoras")
            //window.location.href = window.location.href;
            btnRegresar.style.display = "block";
            contenido.innerHTML = `
              <lb>En este momento no contamos</lb><br>
              <lb>con ninguna consultora en el </lb><br>
              <lb>en el municipio seleccionado</lb><br><br>
            `
            contenido.style.display = "block";
          }
        })
    })

    btnRegresar.addEventListener('click', (event) => {
      window.location.href = window.location.href
    })

    function tabla(data) {
      var whatsappimg = whatsapp;
      //console.log(data)
      contenido.innerHTML += `  
      <tr>
    </tr>`
      for (let valor of data) {
        //console.log(valor.doc_entry)
        contenido.innerHTML += `
      <tr>
      <td align="lefth"><lb>Consultora:</lb><br>${valor.nombre} <br>${valor.apellido}</td>
      <td align="lefth"><lb>Correo:</lb><br>${valor.correo} <br><br> <lb>Celular:</lb><br>${valor.celular}</td>
      <td align="center">
      <lb>Contactame por Whatsapp:</lb><br>
      <lb>dando clic</lb><br><br>
      <a {className="button"} href="https://api.whatsapp.com/send?phone=+502${valor.celular}&text=%C2%A1Hola!%20Te%20encontr%C3%A9%20por%20medio%20del%20Localizador%20de%20Consultoras%20de%20Belleza%20Independientes%20Mary%20Kay.%20%C2%A1Quiero%20conocer%20los%20productos%20Mary%20Kay%C2%AE!">
      <img src=${whatsappimg} width="25px" height="25px" >
      </img>
      </a>
      </td>    
  </tr>
      `
      }
    }

    document.body.style = 'background: #F5DADF;';
  }


  render() {

    return (
      <>

        <div>
          <div style={{ position: "relative", display: "flex" }}>
            <Particles z-index="-1" height="100vh" width="100vw" params={particlesConfig} style={{ position: 'fixed', overflow: "hidden" }} />
          </div>
          <div style={{ position: "relative" }} lign-items="center" z-index="99" display="flex">
            <div className="secundario" style={{ position: "relative" }}>
              <div className="principalLogo">
                <div className="secundarioLogo" width="100vw" height="100vw">
                  <img className="imgL" src={logoMasdel} width="600" height="100" /></div>
              </div>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <div className="principal">
                <div className="secundario">
                  <div id="parrafo1">
                    <p>
                      ¿NUEVA EN MARY KAY?<br></br><br></br>
                      Encuentra la Consultora de Belleza<br></br>
                      Independiente perfecta para ti
                    </p>
                  </div>
                  <div id="parrafo2">
                    <p>
                      Necesitas una Consultora de Belleza<br></br>
                      independiente para comprar tus<br></br>
                      productos. Lo único que necesitamos <br></br>
                      es tu ubicación para ponerte en <br></br>
                      contacto con la persona correcta.
                    </p>
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                      <label className="form-check-label" for="inlineCheckbox1">
                        <a className="underlineHover" href="https://marykay.com.gt/productos/garantia/"
                          target="_blank" rel="noreferrer">
                            Acepto términos y condiciones.
                        </a>
                      </label>
                  </div>                  
                </div>
              </div>
              <br></br>              
              <div className="principaldatosC">
                <div className="secundarioDatosC">
                  <div className="table-responsive">
                    <table id="tabladatosconsultora" className="table">
                      <tbody id="contenido" className="dotosC">
                        <div>
                        </div>
                      </tbody>
                    </table>
                    <div>
                      <button id="btnRegresar" className="buttonR">Seleccionar otra ubicacion</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="principalSelect">
                <div className="secundarioSelect">
                  <div className="d-flex justify-content-center">
                    <br></br>
                    <select name="listaDepartamentos" id="listaDepartamentos" className="from-control" >
                      <option value="" disabled selected>Seleccione un departamento</option>
                      {this.state.listaDepartamentos.map(elemento =>
                      (
                        <option key={elemento.departamento} value={elemento.departamento}>{elemento.departamento}</option>
                      )
                      )}
                    </select>
                  </div>
                  <br></br>
                  <div className="d-flex justify-content-center">
                    <select name="listaMunicipios" id="listaMunicipios" className="from-control" >
                      <option value="" disabled selected>Seleccione un municipio</option>
                      {this.state.listaMunicipios.map(elemento =>
                      (
                        <option key={elemento.municipio} value={elemento.municipio}>{elemento.municipio}</option>
                      )
                      )}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default App;
